'use strict';

const { getDependencyClass } = require('../../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixCarouselCounter extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:carousel:activeSlide'];
        }

        get carousel() {
            return this._carousel || (this._carousel = this.closest('phoenix-carousel'));
        }

        connectedCallback() {
            super.connectedCallback();
            this.separator = this.getAttr('separator') || '/';
        }

        render(currentSlideIndex) {
            this.innerHTML = `${currentSlideIndex + 1} ${this.separator} ${this.carousel.slideIds.length}`;
        }

        broadcastedEventCallback(name, args = {}) {
            const currentSlideIndex = args.detail && args.detail.value;

            if (name === 'phoenix:carousel:activeSlide' && args.target === this.carousel) {
                this.render(currentSlideIndex);
            }
        }
    }
    window.customElements.define('phoenix-carousel-counter', PhoenixCarouselCounter);
});
